module.exports = __webpack_public_path__ + "static/media/player_en.262aa8f4.png";